import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

export const PART_OF_DAY_SCOPE_PARENT = 'PARENT';
export const PART_OF_DAY_SCOPE_ORGANIZATION = 'ORGANIZATION';

export const partOfDayScopeOptions = (strings: any) => [
  { label: strings.partOfDay_scope_parent, value: PART_OF_DAY_SCOPE_PARENT },
  { label: strings.partOfDay_scope_organization, value: PART_OF_DAY_SCOPE_ORGANIZATION },
];

export const AddEditPartOfDayForm = (strings: any, width = 4, isEdit = false, dialogMode = false): FormModel[] => {
  const isFilter = width === 12;
  const fieldWidth = dialogMode ? 3 : width;
  const dialogResponsive = width === 12 ? { xs: 12 } : { xs: 12, sm: 6, md: 3 };

  if (dialogMode) {
    return [
      {
        label: strings.partOfDay_field_code,
        value: '',
        size: 'medium',
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'code',
        disabled: isEdit,
        validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
        responsive: dialogResponsive,
        required: !isEdit,
      },
      {
        label: strings.partOfDay_field_name,
        value: '',
        size: 'medium',
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'name',
        validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 200 }],
        responsive: dialogResponsive,
        required: true,
      },
      {
        label: strings.partOfDay_field_scope,
        value: PART_OF_DAY_SCOPE_ORGANIZATION,
        size: 'medium',
        type: 'drop-down',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'scope',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: dialogResponsive,
        required: true,
        options: partOfDayScopeOptions(strings),
      },
      {
        label: strings.partOfDay_field_sort_order,
        value: 1,
        size: 'medium',
        type: 'text',
        typeValue: 'number',
        variant: 'outlined',
        placeholder: '',
        field: 'sortOrder',
        validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 999999 }],
        responsive: dialogResponsive,
        required: true,
      },
    ];
  }

  const fields: FormModel[] = [];

  fields.push(
    {
      label: strings.partOfDay_field_code,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'code',
      disabled: isEdit,
      validators: isFilter ? [] : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: fieldWidth },
      required: !isFilter && !isEdit,
    },
    {
      label: strings.partOfDay_field_scope,
      value: PART_OF_DAY_SCOPE_ORGANIZATION,
      size: 'medium',
      type: 'drop-down',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'scope',
      validators: isFilter ? [] : [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: fieldWidth },
      required: !isFilter && fieldWidth === 4,
      options: partOfDayScopeOptions(strings),
    },
    {
      label: strings.partOfDay_field_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: isFilter ? [] : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 200 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: fieldWidth },
      required: !isFilter && fieldWidth === 4,
    },
    {
      label: strings.partOfDay_field_color,
      value: '#66BB6A',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '#66BB6A',
      field: 'color',
      validators: isFilter ? [] : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 20 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: fieldWidth },
      required: !isFilter && fieldWidth === 4,
    },
    {
      label: strings.partOfDay_field_sort_order,
      value: 1,
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'sortOrder',
      validators: isFilter ? [] : [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 999999 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: fieldWidth },
      required: !isFilter && fieldWidth === 4,
    },
    {
      label: strings.partOfDay_field_active,
      value: true,
      size: 'medium',
      type: 'checkbox',
      typeValue: 'checkbox',
      variant: 'outlined',
      placeholder: '',
      field: 'active',
      validators: [],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: fieldWidth },
      required: false,
    },
  );

  return fields;
};
